import useTranslation from "@/hooks/useTranslation";
import { useCustomerImpactTotals } from "@/pages/dashboard/hooks/useCustomerImpact";
import MetricWidget from "../../components/MetricWidget/MetricWidget";
import { ImpactMetric } from "../../utils/types";

export default function CustomerImpactTotal({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = useCustomerImpactTotals({ metrics: [metric.key] });
  const translation = useTranslation();

  return (
    <MetricWidget
      title={"Customer footprint"}
      tooltip={translation["dashboard"]["customer"]["total"]}
      loading={isLoading || isFetching}
      format={metric.formatter}
      metric={metric}
      data={{
        value: data?.customer_impact[metric.key],
        comparison: {
          label: "of company total",
          value: data?.company_impact[metric.key],
        },
      }}
    />
  );
}
